(() => {
  let queued = false;
  const update = () => {
    queued = false;
    const launcher = document.getElementById('appstle-loyalty-button');
    let overlap = false;
    if (window.matchMedia('(max-width:749px)').matches && launcher) {
      const rect = launcher.getBoundingClientRect();
      overlap = [...document.querySelectorAll('.noble-home-lifestyle__actions, .noble-nature--madison .noble-nature__button, .noble-texture-card__label')].some(el => {
        const box = el.getBoundingClientRect();
        return box.width && box.height && box.bottom > 0 && box.top < innerHeight && box.left < rect.right + 8 && box.right > rect.left - 8 && box.top < rect.bottom + 8 && box.bottom > rect.top - 8;
      });
    }
    document.body.toggleAttribute('data-noble-home-rewards-overlap', overlap);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, { passive:true });
  window.addEventListener('resize', schedule, { passive:true });
  window.addEventListener('load', schedule, true);
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  schedule();
})();
